module.exports = __webpack_public_path__ + "static/media/step1mobile.38ea4596.png";